import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  useSignupMutation,
  useRefreshMutation,
  selectIsLoggedIn,
  getAuthStatus,
  Signup,
} from '@centerpiece/components';

export const SignupPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const [signup, signupResult] = useSignupMutation();
  const [refresh] = useRefreshMutation();
  const from = (location?.state as any)?.from;

  useEffect(() => {
    if (isLoggedIn) {
      if (from?.pathname) {
        navigate(from.pathname);
      } else {
        navigate('/');
      }
    } else {
      const authStatus = getAuthStatus();
      if (authStatus) {
        refresh();
      }
    }
  }, [isLoggedIn, navigate, from, refresh, signupResult.isSuccess]);

  return <Signup signup={signup} navigate={navigate} />;
};
